import {
  VStack,
  Heading,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  TabIndicator,
  Text,
} from '@chakra-ui/react';
import { useStores } from '../store/store_context';
import PanelTable from '../components/panel_table';
import UserTable from '../components/user_table';
import RoleTable from '../components/role_table';
import AdminHeaderButtons from '../components/admin_header_buttons';
import { useEffect, useState } from 'react';
import {
  getAllPanels,
  getAllUsers,
  getAllRoles,
  getAllPanelsById,
  getAllPanelsByGroups,
  getAllUsersForUsername,
} from '../store/api_funcs';
import GroupTable from '../components/group_table';
import { observer } from 'mobx-react-lite';
import MonitoringPage from './monitoring_page';
import BotTicketsPage from './bot_tickets_page';
import MonitoringAlertsPage from './monitoring_alerts_page';

// import UsersSearch from '../components/users_autocomplete';
// import Histogram from '../components/histogram';

const MainPage = observer(() => {
  const { pageStore } = useStores();
  const [users, setUsers] = useState(null);
  const [panels, setPanels] = useState(null);
  const [panelsGroups, setPanelsGroups] = useState(null);
  const [roles, setRoles] = useState(null);
  const getTableUsers = async () => {
    setUsers(await getAllUsers(pageStore.token));
    console.log(users);
  };
  const getTableUsersForUser = async () => {
    setUsers(await getAllUsersForUsername(pageStore.token, pageStore.username));
    console.log(users);
  };
  const getTablePanels = async () => {
    pageStore.see_all_panels && pageStore.token
      ? setPanels(await getAllPanels(pageStore.token))
      : setPanels(await getAllPanelsById(pageStore.user_id, pageStore.token));
  };
  const getPanelsByGroups = async () => {
    setPanelsGroups(
      await getAllPanelsByGroups(pageStore.user_id, pageStore.token)
    );
  };
  const getTableRoles = async () => {
    setRoles(await getAllRoles(pageStore.token));
  };
  const [tabIndex, setTabIndex] = useState(0); // состояние текущей вкладки
  const isFullAdmin =
    Number(pageStore.role_id) === 1 &&
    Number(pageStore.see_all_panels) === 1 &&
    Number(pageStore.see_all_users) === 1 &&
    Number(pageStore.add_roles) === 1 &&
    Number(pageStore.remote_control_panel) === 1 &&
    Number(pageStore.monitoring_view) === 1;
  const canManageMonitoringAlerts =
    isFullAdmin && Number(pageStore.monitoring_settings) === 1;

  const switchToTab = index => {
    setTabIndex(index);
  };
  useEffect(() => {
    pageStore.see_all_users ? getTableUsers() : getTableUsersForUser();
    getTableRoles();
    getTablePanels();
  }, [pageStore.see_all_users]);

  return (
    <VStack width={'100%'}>
      <AdminHeaderButtons
        changeTab={switchToTab}
        updateUsersTable={getTableUsers}
        usersForPanelForm={users}
        updatePanelsTable={getTablePanels}
        updateRolesTable={getTableRoles}
        rolesForUserFrom={roles}
        panels={panels}
      />
      <Tabs
        width={'100%'}
        index={tabIndex}
        onChange={index => setTabIndex(index)}
        colorScheme="purple"
      >
        <TabList borderBottom={'1px solid rgba(255,255,255,0.72)'} gap={2}>
          <Tab _selected={{ color: '#8B5CF6' }} color={'rgba(255,255,255,0.82)'} fontSize={22}>
            {pageStore.see_all_panels
              ? 'Список панелей'
              : pageStore.only_my_panel
                ? 'Моя панель'
                : 'Мои панели'}
          </Tab>
          {!pageStore.only_my_panel ? (
            <Tab _selected={{ color: '#8B5CF6' }} color={'rgba(255,255,255,0.82)'} fontSize={22}>
              Группы
            </Tab>
          ) : null}

          {!pageStore.only_myself ? (
            <Tab _selected={{ color: '#8B5CF6' }} color={'rgba(255,255,255,0.82)'} fontSize={22}>
              {pageStore.see_all_users
                ? 'Список пользователей'
                : 'Мои операторы'}
            </Tab>
          ) : null}

          {pageStore.add_roles ? (
            <Tab _selected={{ color: '#8B5CF6' }} color={'rgba(255,255,255,0.82)'} fontSize={22}>
              Уровни доступа
            </Tab>
          ) : null}
          {pageStore.remote_control_panel && pageStore.monitoring_view ? (
            <Tab _selected={{ color: '#8B5CF6' }} color={'rgba(255,255,255,0.82)'} fontSize={22}>
              Мониторинг
            </Tab>
          ) : null}
          {isFullAdmin ? (
            <Tab _selected={{ color: '#8B5CF6' }} color={'rgba(255,255,255,0.82)'} fontSize={22}>
              Заявки бота
            </Tab>
          ) : null}
          {canManageMonitoringAlerts ? (
            <Tab _selected={{ color: '#8B5CF6' }} color={'rgba(255,255,255,0.82)'} fontSize={22}>
              Уведомления
            </Tab>
          ) : null}
          {/* {pageStore.analytics ? (
            <Tab _selected={{ color: '#4945FF' }} fontSize={22}>
              Аналитика
            </Tab>
          ) : null} */}
        </TabList>
        <TabIndicator
          mt="-1.5px"
          height="2px"
          bg="#8B5CF6"
          borderRadius="1px"
          color={'#8B5CF6'}
        />

        <TabPanels>
          <TabPanel paddingTop={'4vh'} paddingLeft={0} paddingRight={0}>
            {pageStore.see_all_panels ? (
              <PanelTable
                panels={panels}
                getTablePanels={getTablePanels}
                usersForPanelForm={users}
                getTableUsers={getTableUsers}
              />
            ) : (
              <PanelTable
                panels={panels}
                getTablePanels={getTablePanels}
                usersForPanelForm={users}
                getTableUsers={getTableUsers}
              />
            )}
          </TabPanel>
          {!pageStore.only_my_panel ? (
            <TabPanel paddingTop={'4vh'} paddingLeft={0} paddingRight={0}>
              <GroupTable
                panels={panels}
                getPanelsByGroups={getPanelsByGroups}
                panelsByGroup={panelsGroups}
                usersForPanelForm={users}
              />
            </TabPanel>
          ) : null}
          {!pageStore.only_myself ? (
            <TabPanel paddingTop={'4vh'} paddingLeft={0} paddingRight={0}>
              <UserTable
                users={users}
                getTableUsers={
                  pageStore.see_all_users ? getTableUsers : getTableUsersForUser
                }
                panels={panels}
                rolesForUserForm={roles}
                getTablePanels={getTablePanels}
              />
            </TabPanel>
          ) : null}

          {pageStore.add_roles ? (
            <TabPanel paddingTop={'4vh'} paddingLeft={0} paddingRight={0}>
              <RoleTable getTableRoles={getTableRoles} roles={roles} />
            </TabPanel>
          ) : null}
          {pageStore.remote_control_panel && pageStore.monitoring_view ? (
            <TabPanel paddingTop={'4vh'} paddingLeft={0} paddingRight={0}>
              <MonitoringPage />
            </TabPanel>
          ) : null}
          {isFullAdmin ? (
            <TabPanel paddingTop={'4vh'} paddingLeft={0} paddingRight={0}>
              <BotTicketsPage />
            </TabPanel>
          ) : null}
          {canManageMonitoringAlerts ? (
            <TabPanel paddingTop={'4vh'} paddingLeft={0} paddingRight={0}>
              <MonitoringAlertsPage />
            </TabPanel>
          ) : null}
          {/* {pageStore.analytics ? (
            <TabPanel paddingTop={'8vh'} paddingLeft={0}>
              <VStack align={'flex-start'} width={'100%'}>
                <Text>поиск панели</Text>
                <UsersSearch />
                <Histogram />
              </VStack>
            </TabPanel>
          ) : null} */}
        </TabPanels>
      </Tabs>
    </VStack>
  );
});

export default MainPage;
